// extracted by mini-css-extract-plugin
export default {"triangle":"_2DJEZ","outer":"_1hzMp","inner":"_1qJc0","right":"_3KUfn","left":"_1JwJl"};